module.exports = __webpack_public_path__ + "static/img/orgaiztion.1bd39edc.png";